// Module
var code = `<div class="card">
	<div class="card-header">
		<div class="row">
			<div class="col-md-12 d-flex justify-content-between align-items-center"
				ng-click="ctrl.isCollapsed = !ctrl.isCollapsed" style="cursor: pointer;">
				<span class="card-title h4 mb-0">
					<i class="fas fa-fw"
						ng-class="{'fa-chevron-right': ctrl.isCollapsed, 'fa-chevron-down': !ctrl.isCollapsed}"></i>
					{{filteredFileMedia.length}} File Media</span>
				<div class="d-flex gap-2">
					<button class="btn btn-sm btn-outline-secondary"
						ng-click="ctrl.openResolutionModal(); \$event.stopPropagation()">
						<i class="fas fa-table-list me-1"></i>Resolutions
					</button>
					<button class="btn btn-sm btn-outline-secondary"
						ng-click="ctrl.showFilters = !ctrl.showFilters; \$event.stopPropagation()">
						<i class="fas fa-filter me-1"></i>
						<span ng-if="!ctrl.showFilters">Filters</span>
						<span ng-if="ctrl.showFilters">Hide</span>
					</button>
				</div>
			</div>
		</div>
	</div>
	<div ng-show="!ctrl.isCollapsed">
		<!-- Filter controls - toggleable -->
		<div class="card-body py-2" ng-show="ctrl.showFilters">
			<div class="row g-3 align-items-end">
				<!-- Sort Section -->
				<div class="col-md-6 col-lg-3">
					<label class="form-label small text-muted mb-1">Sort by</label>
					<select class="form-select form-select-sm" ng-model="ctrl.sortOption">
						<option value="name">Name</option>
						<option value="createdAtDesc">Created (Newest First)</option>
						<option value="createdAt">Created (Oldest First)</option>
						<option value="duration">Duration</option>
						<option value="mediaInUse">Usage Count</option>
					</select>
				</div>
				<!-- Usage Filter - only visible when a playlist is open -->
				<div class="col-md-6 col-lg-2" ng-if="ctrl.isSceneActive()">
					<label class="form-label small text-muted mb-1">Usage</label>
					<select class="form-select form-select-sm" ng-model="ctrl.selectedMediaUsage">
						<option value="all">All</option>
						<option value="inUse">In Use</option>
						<option value="notInUse">Not In Use</option>
					</select>
				</div>
				<!-- Date Filter -->
				<div class="col-md-6 col-lg-2">
					<label class="form-label small text-muted mb-1">Date</label>
					<select class="form-select form-select-sm" ng-model="ctrl.selectedDate">
						<option value="">All</option>
						<option ng-repeat="date in ctrl.getUniqueDates()" value="{{date}}">{{date | date:'dd/MM yy
							EEE'}}</option>
					</select>
				</div>
				<!-- Label Filter -->
				<div class="col-md-6 col-lg-3">
					<label class="form-label small text-muted mb-1">Label</label>
					<select class="form-select form-select-sm" ng-model="ctrl.selectedLabel">
						<option value="">All</option>
						<option ng-repeat="label in ctrl.labelsInUse" ng-value="label">{{label.name}}</option>
					</select>
				</div>
				<!-- Clear Button -->
				<div class="col-lg-2 col-md-12">
					<button class="btn btn-sm btn-outline-secondary w-100" ng-click="ctrl.clearFilters()">
						<i class="fas fa-times me-1"></i>Clear Filters </button>
				</div>
			</div>
			<div class="mt-2" ng-if="ctrl.sortOption === 'mediaInUse' && !ctrl.isSceneActive()">
				<small class="text-warning"><i class="fas fa-info-circle me-1"></i>Usage Count requires an open
					playlist. Please select a playlist in edit mode.</small>
			</div>
		</div>
		<div class="file-media-scrollable">
			<div class="flex-media-library">
				<asset-upload-drop-zone class="flex-media-item"></asset-upload-drop-zone>
				<div class="flex-media-item"
					ng-repeat="item in filteredFileMedia = (ctrl.FileMedia | filter:ctrl.filterByMediaUsage | orderBy:ctrl.getSortKey(ctrl.sortOption) | filter:ctrl.filterByDate(ctrl.selectedDate) | filter:ctrl.filterByLabel)">
					<bulk-select class="header" title="{{item.name}}" media-title="item.name"
						on-toggle="ctrl.toggleBulk(item.id)"></bulk-select>
					<div class="content">
						<div ng-repeat="asset in item.assets"
							ng-if="\$first && asset.type === 'video' && asset.height === 2160" class="video4k-label">4K
						</div>
						<img class="thumb" alt="Thumbnail" draggable="false" ng-src="{{ctrl.getThumbnailUrl(item.id)}}"
							ng-click="ctrl.openModal(item)" />
						<div class="controls">
							<div>
								<div class="d-grid">
									<button
										ng-if="ctrl.scene && (ctrl.getOrientations(item.id) === 'both' || ctrl.getOrientations(item.id) === ctrl.scene.orientation)"
										class="btn btn-sm btn-outline-primary"
										ng-class="{'btn-warning': ctrl.getOrientations(item.id) !== 'both' && ctrl.getOrientations(item.id) !== ctrl.scene.orientation}"
										type="button" ng-click="ctrl.addToScene(item.id)"
										ng-disabled="!ctrl.isSceneActive() || ctrl.getEvent(item.id) || !ctrl.getType(item.id)">
										<i class="fas fa-plus-circle"></i> Add to playlist <span
											ng-if="ctrl.mediaInUse[item.id]">({{ ctrl.mediaInUse[item.id] }})</span>
									</button>
								</div>
							</div>
							<div class="d-flex justify-content-between align-items-center">
								<div>
									<i class="fas fa-fw" ng-class="ctrl.getIcon(item.id)"></i>
									<i class="fas fa-fw"
										ng-class="{'fa-arrows-up-down-left-right': ctrl.getOrientations(item.id) === 'both', 'fa-arrows-left-right': ctrl.getOrientations(item.id) === 'l', 'fa-arrows-up-down': ctrl.getOrientations(item.id) === 'p'}"></i>
									<i ng-if="ctrl.getDuration(item.id)" class="fa fa-fw fa-clock-o"></i>
									{{ctrl.getDuration(item.id) | duration}} <i class="fa fa-upload"></i> <span
										title="Upload date"> {{item.createdAt | amDateFormat:'DD/MM YY'}}</span>
								</div>
								<button class="btn btn-sm btn-discreet-danger" type="button"
									ng-click="ctrl.delete(item.id)" ng-disabled="item.sceneCollections">
									<i class="fas fa-trash"></i>
								</button>
							</div>
							<div class="text-end">
								<span ng-show="ctrl.getEvent(item.id) === 'analyze'">
									<span>Analyzing</span>
									<i class="fas fa-circle-notch fa-spin"></i>
								</span>
							</div>
							<div>
								<media-labels filemedia-id="item.id"></media-labels>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- Video Preview Modal - Bootstrap 5 -->
		<div class="modal fade" id="videoModal" tabindex="-1" role="dialog" aria-labelledby="videoModalLabel"
			aria-hidden="true">
			<div class="modal-dialog modal-lg" style="height: 90%" role="document">
				<div class="modal-content" style="height: 100%;">
					<div class="modal-header">
						<h3 class="modal-title text-center" id="videoModalLabel">Media Preview</h3>
						<button type="button" class="btn-close" ng-click="ctrl.closeModal()"
							aria-label="Close"></button>
					</div>
					<div class="modal-body" style="max-height: 85%; overflow-y: auto;">
						<div class="container-fluid">
							<div class="row">
								<div class="col-md-{{12 / ctrl.currentItem.assets.length}}"
									ng-repeat="asset in ctrl.currentItem.assets">
									<div class="modal-video-container">
										<div class="modal-video-frame" ng-if="asset.type === 'video' || asset.type === 'image'"
											ng-class="{ 'modal-video-frame--pillarbox': overlay.mode === 'pillarbox' }"
											ng-style="overlay.frameStyle"
											ng-init="overlay = ctrl.getPreviewSafeAreaOverlay(asset)">
											<video ng-if="asset.type === 'video'" controls autoplay muted disableRemotePlayback>
												<source ng-src="{{ctrl.S3url}}/{{ asset.fileKey }}" type="video/mp4">
											</video>
											<img ng-if="asset.type === 'image'" ng-src="{{ctrl.S3url}}/{{ asset.fileKey }}" alt="{{ ctrl.currentItem.name }}" />
											<div ng-if="overlay" class="preview-safe-area">
												<div ng-if="overlay.mode === 'pillarbox'" class="preview-safe-area__bar"
													ng-style="overlay.leftBarStyle"></div>
												<div ng-if="overlay.mode === 'pillarbox'" class="preview-safe-area__bar"
													ng-style="overlay.rightBarStyle"></div>
												<div class="preview-safe-area__box" ng-style="overlay.boxStyle"></div>
												<div class="preview-safe-area__label"
													title="{{ctrl.getPreviewSafeAreaTooltip(overlay)}}">
													{{ctrl.getPreviewSafeAreaLabel(overlay)}}</div>
											</div>
										</div>
									</div>
									<table style="font-size: 0.8em;" class="table table-sm table-striped">
										<tbody>
											<tr ng-repeat="(key, value) in asset" ng-if="key !== 'hash'">
												<th>{{ key }}</th>
												<td>{{ key === 'bytes' ? (value / 1048576 | number:1) + ' MB' : value }}</td>
											</tr>
											<tr ng-if="asset.width && asset.height">
												<th>aspect</th>
												<td>{{ (asset.width / asset.height).toFixed(2) }}:1</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary" ng-click="ctrl.closeModal()">Close</button>
					</div>
				</div>
			</div>
		</div>

		<!-- Resolution Overview Modal -->
		<div class="modal fade" id="resolutionModal" tabindex="-1" role="dialog" aria-labelledby="resolutionModalLabel" aria-hidden="true">
			<div class="modal-dialog modal-xl" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="resolutionModalLabel">
							<i class="fas fa-table-list me-2"></i>Media Resolutions
						</h5>
						<button type="button" class="btn-close" ng-click="ctrl.closeResolutionModal()" aria-label="Close"></button>
					</div>
					<div class="modal-body p-0" style="max-height: 72vh; overflow-y: auto;">
						<table class="table table-sm table-striped table-hover mb-0">
							<thead class="table-dark sticky-top">
								<tr>
									<th ng-click="ctrl.sortResolutionBy('name')" style="cursor: pointer; white-space: nowrap;">
										Name <i class="fas fa-xs ms-1" ng-class="ctrl.resolutionSort.key === 'name' ? (ctrl.resolutionSort.reverse ? 'fa-sort-down' : 'fa-sort-up') : 'fa-sort'"></i>
									</th>
									<th ng-click="ctrl.sortResolutionBy('type')" style="cursor: pointer; white-space: nowrap;">
										Type <i class="fas fa-xs ms-1" ng-class="ctrl.resolutionSort.key === 'type' ? (ctrl.resolutionSort.reverse ? 'fa-sort-down' : 'fa-sort-up') : 'fa-sort'"></i>
									</th>
									<th ng-click="ctrl.sortResolutionBy('orientation')" style="cursor: pointer; white-space: nowrap;">
										Orientation <i class="fas fa-xs ms-1" ng-class="ctrl.resolutionSort.key === 'orientation' ? (ctrl.resolutionSort.reverse ? 'fa-sort-down' : 'fa-sort-up') : 'fa-sort'"></i>
									</th>
									<th ng-click="ctrl.sortResolutionBy('width')" style="cursor: pointer; white-space: nowrap;">
										Resolution <i class="fas fa-xs ms-1" ng-class="ctrl.resolutionSort.key === 'width' ? (ctrl.resolutionSort.reverse ? 'fa-sort-down' : 'fa-sort-up') : 'fa-sort'"></i>
									</th>
									<th ng-click="ctrl.sortResolutionBy('aspect')" style="cursor: pointer; white-space: nowrap;">
										Aspect <i class="fas fa-xs ms-1" ng-class="ctrl.resolutionSort.key === 'aspect' ? (ctrl.resolutionSort.reverse ? 'fa-sort-down' : 'fa-sort-up') : 'fa-sort'"></i>
									</th>
									<th ng-click="ctrl.sortResolutionBy('bitrate')" style="cursor: pointer; white-space: nowrap;">
										Bitrate <i class="fas fa-xs ms-1" ng-class="ctrl.resolutionSort.key === 'bitrate' ? (ctrl.resolutionSort.reverse ? 'fa-sort-down' : 'fa-sort-up') : 'fa-sort'"></i>
									</th>
								</tr>
							</thead>
							<tbody>
								<tr ng-repeat="row in ctrl.resolutionRows | orderBy:ctrl.resolutionSort.key:ctrl.resolutionSort.reverse">
									<td>{{ row.name }}</td>
									<td><i class="fas fa-fw" ng-class="row.type === 'video' ? 'fa-film' : 'fa-image'"></i></td>
									<td><i class="fas fa-fw" ng-class="{'fa-arrows-up-down-left-right': row.orientation === 'both', 'fa-arrows-left-right': row.orientation === 'l', 'fa-arrows-up-down': row.orientation === 'p'}"></i></td>
									<td><code>{{ row.width }} × {{ row.height }}</code></td>
									<td><code>{{ row.aspect | number:2 }}:1</code></td>
									<td><code ng-if="row.bitrate">{{ row.bitrate | number:1 }} Mbps</code><span ng-if="!row.bitrate">–</span></td>
								</tr>
							</tbody>
						</table>
					</div>
					<div class="modal-footer">
						<small class="text-muted me-auto">{{ ctrl.resolutionRows.length }} assets</small>
						<button type="button" class="btn btn-secondary" ng-click="ctrl.closeResolutionModal()">Close</button>
					</div>
				</div>
			</div>
		</div>
	</div>`;
// Exports
export default code;